import { GetProps, Tag, theme } from 'antd';
import { FC, memo, useMemo } from 'react';
import { ShieldLockFill, ShieldSlashFill } from 'react-bootstrap-icons';

import { CircleSpinnerIcon } from '@/common/components';

import { Domain, DomainDeployStatus } from '@/modules/Domains';

interface Props {
  isHttps: Domain['isHttps'];
  isDeployed: Domain['isDeployed'];
  deployStatus?: Domain['deployStatus'];
  withSpinner?: boolean;
  big?: boolean;
  simple?: boolean;
}

export const DomainSchemeTag: FC<Props> = memo(({ isHttps, isDeployed, deployStatus, big = false, simple = false, withSpinner = false }) => {
  const { token: { colorInfo, orange5 } } = theme.useToken();

  const text = simple ? '' : <>режим:&nbsp;</>;
  const fontSize = big ? 14 : 12;
  const colors = useMemo((): [GetProps<typeof Tag>['color'], string | undefined] => {
    if (isDeployed && (deployStatus ? deployStatus === DomainDeployStatus.Deployed : true)) {
      return [isHttps ? 'success' : 'gold', undefined];
    }
    if (deployStatus) {
      if (deployStatus === DomainDeployStatus.Failed) {
        return ['red', undefined];
      }
      if (deployStatus === DomainDeployStatus.Pending) {
        return ['default', orange5];
      }
      if (deployStatus === DomainDeployStatus.Deploying || deployStatus === DomainDeployStatus.Shutdowning) {
        return ['default', colorInfo];
      }
    }
    return ['default', undefined];
  }, [isHttps, deployStatus, isDeployed, orange5, colorInfo]);

  return (
    <>
      <Tag
        color={ colors[0] }
        bordered={ !simple }
        style={{ fontSize }}
      >
        <>
          { text }
          <strong>{ isHttps ? 'HTTPS' : 'HTTP' }</strong>
        </>
        &nbsp;
        { isHttps ? <ShieldLockFill size={ fontSize }/> : <ShieldSlashFill size={ fontSize }/> }
        {
          (withSpinner && colors[1]) && <>
            &nbsp;<CircleSpinnerIcon color={ colors[1] } size={ fontSize }/>
          </>
        }
      </Tag>
    </>
  );
});
